import React, { useEffect, useState } from "react";
import { Alert as AlertUI, Collapse } from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledAlert = styled(AlertUI)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    "& .MuiAlert-icon": {
        fontSize: "1.5rem",
    }
}));

export const Alert = ({ severity = "info", duration = 5000, children, onClose, showCloseButton=true }) => {

    const [open, setOpen] = useState(true);

    useEffect(() => {
        if (duration <= 0) return;
        const timer = setTimeout(() => {
            setOpen(false);
            if (onClose) onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const handleClose = () => {
        setOpen(false);
        if (onClose) onClose();
    };

    return (
        <Collapse in={open}>
            <StyledAlert
                severity={severity}
                onClose={showCloseButton ? handleClose : undefined}
            >
                {children}
            </StyledAlert>
        </Collapse>
    );
};